export const services = [
  {
    id: 1,
    title: "Détox Générale (Hijama)",
    description: "Protocole complet de détoxification par Hijama. Effets revitalisants pour purifier votre organisme et retrouver votre vitalité naturelle.",
    image: "https://customer-assets.emergentagent.com/job_wellness-impress/artifacts/oybcl1vi_Capture%20d%E2%80%99e%CC%81cran%202025-11-08%20a%CC%80%2015.32.26.png",
    price: "70€",
    reduction: "Réduction de 20€ pour les moins de 25 ans",
    benefits: ["Purification complète", "Effet revitalisant", "Boost d'énergie", "Sensation de légèreté"]
  },
  {
    id: 3,
    title: "Massage Sportif",
    description: "Spécialement conçu pour les sportifs. Préparation avant l'effort et récupération optimale après l'entraînement pour des performances accrues.",
    image: "https://customer-assets.emergentagent.com/job_wellness-impress/artifacts/eofs9s0z_Capture%20d%E2%80%99e%CC%81cran%202025-11-08%20a%CC%80%2015.52.34.png",
    price: "50€",
    reduction: null,
    benefits: ["Préparation musculaire", "Récupération rapide", "Prévention des blessures", "Amélioration des performances"]
  },
  {
    id: 2,
    title: "Hijama Ciblées pour une articulation",
    description: "Traitement spécifique pour les douleurs articulaires et pathologies ciblées. Approche personnalisée pour soulager efficacement vos maux articulaires.",
    image: "https://customer-assets.emergentagent.com/job_wellness-impress/artifacts/8cvgzxoz_Capture%20d%E2%80%99e%CC%81cran%202025-11-08%20a%CC%80%2016.21.40.png",
    price: "80€",
    reduction: "Réduction de 20€ pour les moins de 25 ans",
    benefits: ["Soulagement des douleurs articulaires", "Traitement ciblé", "Réduction de l'inflammation", "Amélioration de la mobilité"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mehdi",
    service: "Hijama détox complète",
    text: "Franchement une expérience incroyable. Je m'attendais à juste me sentir détendu, mais j'ai vraiment senti un vrai soulagement dans le dos et une légèreté générale dès le lendemain. Halil explique tout clairement, on se sent en confiance du début à la fin. Je recommande les yeux fermés !"
  },
  {
    id: 2,
    name: "Sarah",
    service: "Massage + lampe infrarouge",
    text: "Je suis venue pour des tensions cervicales que je traînais depuis des semaines. Le massage combiné à la chaleur de la lampe infrarouge m'a complètement détendue. Résultat : plus de maux de tête, meilleure posture et un vrai moment de bien-être. Merci pour ton professionnalisme et ta bienveillance !"
  },
  {
    id: 3,
    name: "Julien",
    service: "Hijama dos + jambes",
    text: "Je fais beaucoup de sport et j'avais souvent les jambes lourdes après mes entraînements. Après la séance de Hijama, j'ai ressenti une différence énorme ! Moins de fatigue musculaire, meilleure récupération. En plus, l'ambiance est apaisante et propre."
  },
  {
    id: 4,
    name: "Tugce",
    service: "Hijama ciblée épaule + dos",
    text: "Je souffrais de douleurs aux épaules à cause du stress et du travail. Dès la première séance, j'ai senti une vraie amélioration. Halil prend le temps d'écouter, d'expliquer et de rassurer. Une approche très humaine, ça fait plaisir !"
  }
];

export const practitionerInfo = {
  name: "Halilhilmi Avci",
  title: "Praticien en Kinésithérapie, Hijama et Massage Thérapeutique",
  description: "Formé en kinésithérapie, en Hijama et en massage thérapeutique, je vous accompagne avec une approche humaine et bienveillante. Ma pratique repose sur une compréhension globale du corps pour vous offrir des soins personnalisés et efficaces.",
  image: "https://images.unsplash.com/photo-1758273241260-f49172d876e3"
};

export const contactInfo = {
  location: "Mons, Belgique",
  locationNote: "Adresse exacte communiquée après réservation",
  homeService: "Déplacements à domicile jusqu'à Charleroi",
  phone: "+32 489 95 30 24",
  email: "hg.avci@hotmail.com",
  instagram: "@wellness.impress",
  instagramUrl: "https://instagram.com/wellness.impress",
  calendlyUrl: "https://calendly.com/h-gavci1907/30min"
};